import VCard from './vcard.js';
import VCards from "./vcards";

import './plugin.js';

export { VCard, VCards };
